import Pusher from 'pusher-js';
// import { isUserLoggedIn } from "../utility/Utils";

// Pusher.logToConsole = true;
// Pusher.log = function (message) {
//   console.log(message); // custom logging logic
// };

export const PusherJS = () => {
  const accessToken = localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN);
  return new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
    wsHost: process.env.REACT_APP_PUSHER_HOST,
    wsPort: process.env.REACT_APP_PUSHER_PORT,
    wssPort: process.env.REACT_APP_PUSHER_PORT,
    forceTLS: true,
    encrypted: true,
    disableStats: true,
    reconnectionDelay: 2000,
    // activityTimeout: 2000, // time gap between reconnection attempts (in milliseconds)
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    authEndpoint: `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_USER_AUTH_ENDPOINT}`,
    auth: {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json'
      }
    }
  });
};

